jQuery(document).ready(function($) {

    var search = $('#borough_search');
    var input = search.find('input');
    var location = $('#borough_location');
    var boroughs = []
    
    $('.borough__title').each(function(){
        boroughs.push({id: $(this).attr('data_id'), name: $(this).html()});
    });

    if (search.length < 1 && location.length < 1) {return;}

    ///////////////////////////
    // search WORD or postcode
    ///////////////////////////

    // $('#borough_search input').change(function(e){searchPostcode(e)});
    $('#borough_search input').keyup(function(e){searchPostcode(e)});

    function searchPostcode(e){
        e.preventDefault();
        var boroughOrPostcode = removeTags(input.val());
        
        $('.borough').removeClass('active');
        $('.borough-suggestions').removeClass('hide');

        var findBorough = findMatches( boroughOrPostcode );

        if (findBorough && findBorough.length === 1) {
            // $('.borough-suggestions').html(findBorough[0].name);
            matchSuccess(findBorough[0].id);

        } else if (findBorough && findBorough.length > 1) {

            var possibleBoroughs = '';
            for (var bb = 0; bb < findBorough.length; bb++) {
                if (bb > 9) {
                    break;
                }
                possibleBoroughs += '<div class="suggestion" tabindex="0">' + findBorough[bb].name + '</div>';
            }
            $('.borough-suggestions').html(possibleBoroughs);

        } else {

            $('.borough-suggestions').html(' ');

            $.ajax({
                url: "https://api.postcodes.io/postcodes/" + boroughOrPostcode + "/autocomplete", 
                success: function(result){
                    var foundBoroughs = result.result;
                    if (foundBoroughs && foundBoroughs.length === 1) {
                        $.ajax({
                            url: "https://api.postcodes.io/postcodes/" + foundBoroughs[0], 
                            success: function(res) {
                                matchResultToBorough(res);
                            },
                            error: function(res){ logError(res); }
                        });
                        
                        $('.borough-suggestions').html('GOT IT');
                    } else if (foundBoroughs && foundBoroughs.length > 1) {
                        // print possibles
                        var possiblePostcodes = '';
                        for (var i = 0; i < foundBoroughs.length; i++) {
                            possiblePostcodes += '<div class="suggestion" tabindex="0">' + foundBoroughs[i] + '</div>';
                        }

                        $('.borough-suggestions').html(possiblePostcodes);
                    } else {
                        $('.borough-suggestions').html('No boroughs found');
                    }

                },
                error: function(result){ logError(result); }

            });
        }        
    }


    ////////////////////////
    // User browser location
    ////////////////////////

    location.click(function(e){
        e.preventDefault();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(checkPosition);
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
             
    });

      
    function checkPosition(position) {
        
        if (position && position.coords && position.coords.longitude && position.coords.latitude) {
            var lon = position.coords.longitude;
            var lat = position.coords.latitude;
        }
        $.ajax({
            url: "https://api.postcodes.io/postcodes?lon=" + lon + "&lat=" + lat, 
            success: function(result){
                if (result && result.result && result.result[0]) {
                    var foundLoc = result.result[0];
                    input.val(foundLoc.primary_care_trust);
                }
                matchResultToBorough(result);
            },
            error: function(result){ logError(result); }

        });

    }

    ///////////////////////////
    // matchResultToBorough
    ///////////////////////////

    function matchResultToBorough(res) {

        if ( 'London' !== res.result.region) {
            $('.borough-suggestions').html('Location detected as outside London');
            $('.borough-suggestions').removeClass('hide');
        } else {
            var foundBorough = findMatches(res.result.primary_care_trust);
            matchSuccess(foundBorough[0].id);
        }

    }

    function findMatches(wordToMatch) {
        return boroughs.filter(borough => {
            const regex = new RegExp(wordToMatch, 'gi');
            return borough.name.match(regex);
        });
    }

    function matchSuccess (id) {
        $('.borough-suggestions').addClass('hide');
        $('#borough-' + id).addClass('active');
    }


    ////////////////////
    // suggestions
    ////////////////////

    $('body').click(function(e) {
        
        ////////////////////
        // click suggestion
        ////////////////////
        if ($(e.target).hasClass('suggestion')) {
            input.val($(e.target).html());
            searchPostcode(e);
        }

        ////////////////
        // click elsewhere to hide suggestions
        ////////////////
        if ($(e.target).closest('.borough-suggestions').length === 0 ) {
            $('.borough-suggestions').addClass('hide');
        }
    });

    /////////////////////
    // keyboard
    /////////////////////

    var inputFocussed = false;
    var focussed;

    $('.lyg-borough-finder').keydown(function(e){
        
        if (e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 13) {
            return;
        } else {
            e.preventDefault();
            e.stopPropagation();
        }

        inputFocussed = $('#borough_search input:focus');
        focussed = $(':focus');

        if (e.keyCode === 13) { // enter
            input.val($(':focus').html());
            $('.borough-suggestions').addClass('hide');
            searchPostcode(e);
        } else if (e.keyCode === 38) { // up
            focussed.prev().focus();
        } else if (e.keyCode === 40) {// down
            if (inputFocussed.length > 0) {

                $('.suggestion')[0].focus();

            } else {

                focussed.next().focus();
            }
        }

    });

    ///////////////////
    // postcode.io error
    ///////////////////

    function logError(result) {
        if (result && result.responseJSON && result.responseJSON.error) {
            console.log(result.responseJSON.error);
        } else {
            console.log(result);
        }
    }

    ////////////
    // Sanitize
    ////////////

    var tagBody = '(?:[^"\'>]|"[^"]*"|\'[^\']*\')*';

    var tagOrComment = new RegExp(
        '<(?:'
        // Comment body.
        + '!--(?:(?:-*[^->])*--+|-?)'
        // Special "raw text" elements whose content should be elided.
        + '|script\\b' + tagBody + '>[\\s\\S]*?</script\\s*'
        + '|style\\b' + tagBody + '>[\\s\\S]*?</style\\s*'
        // Regular name
        + '|/?[a-z]'
        + tagBody
        + ')>',
        'gi');

    function removeTags(html) {
        var oldHtml;
        do {
            oldHtml = html;
            html = html.replace(tagOrComment, '');
        } while (html !== oldHtml);
        return html.replace(/</g, '&lt;');
    }

});